import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { identityRecordOfFieldEditorOptions, getFieldError, defaultGetItemValue } from "./utils";
import { useFieldToTextField } from "./TextFields";
import { DployAutocomplete } from "./DployAutocomplete";
export function MuiAutocompleteField(props) {
    const { onSelectItem, valueKey, labelKey, emptyEqualsZero, options, formatString, italicText, boldText, form, field, errorDisplay, multiple, modalText, ...rest } = props;
    const { getItemValue = defaultGetItemValue, items = [] } = props;
    const { errors, touched, setFieldValue } = form;
    const onChangeSingle = useCallback((e, selected) => {
        const value = selected && getItemValue(selected);
        setFieldValue(field.name, value);
        if (onSelectItem)
            onSelectItem(selected);
    }, [getItemValue, setFieldValue, field.name, onSelectItem]);
    const onChangeMultiple = useCallback((e, selected) => {
        const value = selected ? selected.map(getItemValue) : [];
        setFieldValue(field.name, value);
        if (onSelectItem)
            onSelectItem(selected);
    }, [getItemValue, setFieldValue, field.name, onSelectItem]);
    const { autoComplete, value, ...textFieldProps } = useFieldToTextField(props);
    if (multiple) {
        return (_jsx(DployAutocomplete, { searchable: true, ...rest, ...textFieldProps, ...getFieldError(errors, touched, field.name, errorDisplay), multiple: true, defaultValue: rest.defaultValue, value: value, onChange: onChangeMultiple }));
    }
    return (_jsx(DployAutocomplete, { searchable: true, ...rest, ...textFieldProps, ...getFieldError(errors, touched, field.name, errorDisplay), defaultValue: rest.defaultValue, value: items.find(v => getItemValue(v) === value), onChange: onChangeSingle }));
}
export function MuiSelectField(props) {
    const { onSelectItem, valueKey, labelKey, emptyEqualsZero, options, formatString, italicText, boldText, form, field, errorDisplay, multiple, modalText, disableClearable, ...rest } = props;
    const { getItemValue = defaultGetItemValue, items = [] } = props;
    const { errors, touched, setFieldValue } = form;
    const onChangeSingle = useCallback((e, selected) => {
        const value = selected && getItemValue(selected);
        setFieldValue(field.name, value);
        if (onSelectItem)
            onSelectItem(selected);
    }, [getItemValue, setFieldValue, field.name, onSelectItem]);
    const onChangeMultiple = useCallback((e, selected) => {
        const value = selected ? selected.map(getItemValue) : [];
        setFieldValue(field.name, value);
        if (onSelectItem)
            onSelectItem(selected);
    }, [getItemValue, setFieldValue, field.name, onSelectItem]);
    const { autoComplete, value, ...textFieldProps } = useFieldToTextField(props);
    if (multiple) {
        return (_jsx(DployAutocomplete, { searchable: false, ...rest, ...textFieldProps, ...getFieldError(errors, touched, field.name, errorDisplay), multiple: true, defaultValue: rest.defaultValue, value: value, onChange: onChangeMultiple }));
    }
    return (_jsx(DployAutocomplete, { searchable: false, ...rest, ...textFieldProps, ...getFieldError(errors, touched, field.name, errorDisplay), defaultValue: rest.defaultValue, value: items.find(v => getItemValue(v)?.toString() === value?.toString()), onChange: onChangeSingle, clearable: !disableClearable }));
}
export const EditorAutocompleteFields = identityRecordOfFieldEditorOptions({
    MuiAutocompleteField: {
        editableOptions: {
            optionPairs: true
        }
    },
    MuiSelectField: {
        editableOptions: {
            optionPairs: true,
            multiple: true,
            disableClearable: true
        }
    }
});
//# sourceMappingURL=MuiSelectFields.js.map